import clone from 'clone'
import fields from '@/sui/data/sheets/edit/fields'
import common from '@/sui/data/sheets/convert/common'

function pneu (f) {
  return `pneu${f}`
}

function sep (f) {
  return `sep${f}`
}

const pneumopathy = (function () {
  function build (v) {
    const micro = clone(common.specialMicroOrgs.virus[v])
    micro.cfield = pneu(fields.microOrg)
    return [
      { field: fields.episod, cfield: pneu(fields.episod), special: 'date' },
      { field: fields.diagnosis, cfield: pneu(fields.diagnosis) },
      { field: fields.covidStatus, cfield: pneu(fields.covidStatus) },
      micro,
      { field: fields.diagDate, cfield: pneu(fields.diagDate), special: 'date' },
      { field: fields.origin, cfield: pneu(fields.origin) }
    ]
  }

  return {
    v1: build('v1'),
    v2: build('v2')
  }
})()

const sepsis = (function () {
  function build (v) {
    const result = [
      { field: fields.episod, cfield: sep(fields.episod), special: 'date' },
      { field: fields.origin, cfield: sep(fields.origin) },
      { field: fields.covidStatus, cfield: sep(fields.covidStatus) },
      { field: fields.insertion, cfield: sep(fields.insertion), special: 'date' },
      {
        field: fields.insertion,
        cfield: sep(fields.enfInsertionDate),
        special: 'date'
      },
      { field: fields.insertionSite, cfield: sep(fields.insertionSite) },
      { field: fields.removed, cfield: sep(fields.removed) },
      { field: fields.removal, cfield: sep(fields.removal), special: 'date' },
      { field: fields.enfCatheter, cfield: sep(fields.enfCatheter) },
      { field: `${fields.entrance}_v2`, cfield: sep(fields.entrance) },
      { field: fields.diagDate, cfield: sep(fields.diagDate), special: 'date' },
      { field: fields.divDiag, cfield: sep(fields.divDiag) },
      { field: fields.lipids, cfield: sep(fields.lipids) },
      { field: fields.urinary, cfield: sep(fields.urinary) },
      {
        field: fields.urinaryStart,
        cfield: sep(fields.urinaryStart),
        special: 'date'
      },
      { field: fields.urinaryRemoved, cfield: sep(fields.urinaryRemoved) },
      { field: fields.urinaryEnd, cfield: sep(fields.urinaryEnd), special: 'date' },
      {
        field: `${fields.enfCatheterType}_v2`,
        cfield: sep(fields.enfCatheterType)
      },
      { field: fields.intubated, cfield: sep(fields.intubated) },
      { field: fields.intubStart, cfield: sep(fields.intubStart), special: 'date' }
    ]
    if (v === 2) {
      result.push(
        { field: fields.reintubated, cfield: sep(fields.reintubated) },
        { field: fields.intubEnd, cfield: sep(fields.intubEnd), special: 'date' }
      )
    }
    return result
  }

  return {
    v1: build(1),
    v2: build(2)
  }
})()

function build (v) {
  const result = [
    { field: fields.expManagment },
    { field: fields.sheetNumber, special: 'numeric' },
    { field: fields.uf },
    { field: fields.uf, cfield: `sep${fields.uf}` },
    { field: fields.birthdate, special: 'date' },
    { field: fields.sex },
    { field: fields.entrydate, special: 'date' },
    { field: fields.immuno },
    { field: fields.episodImmuno },
    { field: fields.cancer },
    { field: fields.antibio },
    { field: fields.portageBmrBhre },
    { field: fields.bmrBhreMicroOrgs, array: common.bmrBhreMicroOrgs },
    { field: fields.mixManagment },
    { field: fields.origin, cfield: fields.patientOrigin },
    { field: fields.origin, cfield: fields.neoOrigin },
    { field: fields.birthSite },
    { field: fields.birthWeight, special: 'numeric' },
    { field: fields.gestationalAge, special: 'numeric' },
    { field: fields.ventilation },
    { field: fields.leucomalacy },
    { field: fields.trauma },
    { field: fields.diagnosis },
    { field: fields.mainSeverity, special: 'mainSeverity' },
    { field: fields.otherSeverity, special: 'otherSeverity' },
    { field: fields.dead },
    { field: fields.death, special: 'date' },
    { field: fields.ecmo },
    { field: fields.intubated },
    { field: fields.intubStart, special: 'date' },
    { field: fields.reintubated },
    { field: fields.intubEnd, special: 'date' }
  ]

  const lists = {
    v1: [common.bacteremia.v2, sepsis.v1, pneumopathy.v1],
    v2: [common.bacteremia.v3, sepsis.v2, pneumopathy.v1],
    v3: [common.bacteremia.v4, sepsis.v2, pneumopathy.v2],
    v4: [common.bacteremia.v5, sepsis.v2, pneumopathy.v2],
    v5: [common.bacteremia.v6, sepsis.v2, pneumopathy.v2]
  }

  function addLists (r, v) {
    r.push(
      {
        field: fields.bacteremia,
        object: v[0]
      },
      {
        field: fields.sepsis,
        object: v[1]
      },
      {
        field: fields.pneumopathy,
        object: v[2]
      }
    )
  }

  if (v === 1) {
    addLists(result, lists.v1)
  } else if (v < 4) {
    addLists(result, lists.v2)
  } else {
    result.push({ field: fields.bmi, special: 'numeric' })
    if (v === 4) {
      addLists(result, lists.v3)
    } else if (v === 5) {
      addLists(result, lists.v4)
    } else {
      addLists(result, lists.v5)
    }
  }

  const ut = v >= 5 ? 'unitType_v2' : 'unitType'
  result.push(
    { field: fields.unitType, special: ut },
    {
      field: fields.unitType,
      cfield: `sep${fields.unitType}`,
      special: ut
    }
  )

  return result
}

export default {
  '2020': build(1),
  '2021': build(2),
  '2022': build(3),
  '2023': build(4),
  '2024': build(5),
  '2025': build(6),
  '2026': build(6)
}
